import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import ConfigSwitch from "../../../../../../components/common/BriaSwitch/Config/ConfigSwitch";
import { useAppStore } from "../../../../../../hooks/useStores";

const TextToImageEnhanceSwitch = () => {
	const { t } = useTranslation("image_generation", { keyPrefix: "playground.textToImage.config.enhanceImage" });
	const { textToImageStore } = useAppStore();
	const { handleConfigChange } = textToImageStore;

	const handleEnhanceImageChange = (checked: boolean) => {
		handleConfigChange("enhance_image", checked);
	};

	return (
		<ConfigSwitch
			label={t("label")}
			info={t("info")}
			checked={textToImageStore.config.enhance_image || false}
			onChange={handleEnhanceImageChange}
		/>
	);
};

export default observer(TextToImageEnhanceSwitch);
